import { render, staticRenderFns } from "./WordView.vue?vue&type=template&id=d464a8d6&scoped=true&lang=pug"
import script from "./WordView.vue?vue&type=script&lang=js"
export * from "./WordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d464a8d6",
  null
  
)

export default component.exports